import { usePageEventContext, withPageEvent } from '../../../shared/flow-event';
import { createInitialState, createTracker } from './tracker';
import type {
  SignupByOtpOneCredentialFlowEventDefinition,
  SignupByOtpOneCredentialFlowEventState,
} from './types';

export function useSignupByOtpOneCredentialFlowEvent() {
  return usePageEventContext<SignupByOtpOneCredentialFlowEventDefinition>();
}

export function withSignupByOtpOneCredentialFlowEvent<
  Props extends object = {}
>() {
  return withPageEvent<
    SignupByOtpOneCredentialFlowEventDefinition,
    SignupByOtpOneCredentialFlowEventState,
    Props
  >(createInitialState(), createTracker());
}
